import axios from 'axios'
import {isArray} from 'lodash'
import {asResponse} from '../util'
import {mutate} from 'swr'

const convertActivePageToSkip = (query = {}) => {
  let {activePage = '1'} = query
  activePage = parseInt(activePage)
  return (activePage - 1) * 10
}

export const BACKUPS_SWR_KEY = ({query}) => {
  const skip = convertActivePageToSkip(query)
  let {selectedNames = ''} = query
  selectedNames = isArray(selectedNames) ? selectedNames : [selectedNames]
  selectedNames = selectedNames.join(',')
  const selectedNamesQueryParam = selectedNames.length ? `&selectedNames=${selectedNames}` : ''
  return [`/bff/backups?skip=${skip}&limit=10&sort={"name": 1, "createdAt": -1}&calcTotalCount=true&includeAggregates=true${selectedNamesQueryParam}`, skip, selectedNames]
}

export const getBackups = async (url) => {
  const resp = await asResponse(axios.get(url))
  let backups = resp.data ? (resp.data.results || []) : []
  let totalBackupsCount = resp.data ? (resp.data.metadata.totalCount || 0) : 0
  let backupNames = resp.data ? (resp.data.names || []) : []
  return {backups, totalBackupsCount, backupNames}
}

export const BACKUP_SWR_KEY = ({backupId}) => [`/bff/backups/${backupId}`, backupId]

export const getBackup = async (url, backupId) => {
  if (!backupId) {
    return {
      backup: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${backupId}', backupId)))
  const backup = resp.data
  return {
    backup
  }
}

export const mutateBackups = async function () {
  let args = Array.from(arguments)
  args = [BACKUPS_SWR_KEY, ...args]
  return mutate.apply(this, args)
}

export const restoreBackup = async (backupId, name) => {
  const resp = await asResponse(axios.post('/bff/backups/restore', {backupId, name}))
  return resp.data
}